export default __webpack_public_path__ + "static/media/image.427a68e8.png";